module.exports = __webpack_public_path__ + "img/latte_hair.c69d2fcc.jpg";